export default __webpack_public_path__ + "media/inform_pro_user_profile_email/title_locale_de-f42df079.png";